<template>
  <div
    :style="{
      position: 'relative',
      height: `${height}${typeof height == 'number' ? 'px' : ''}`,
      border: `${border !== 'none' ? '1px var(--color-border-3) ' + border : ''}`,
      overflowY: `${isWarnPage ? 'auto' : 'hidden'}`
    }"
  >
    <div v-if="isWarnPage" class="warn-box">
      <img class="warn-img" src="../../assets/images/iframe-img.svg" alt="" />
      <div>{{ $t('多维表格在当前页面环境无法正常登录') }}</div>
      <div class="warn-mini-title">{{ $t('点击按钮前往查看') }}</div>
      <jw-button type="primary" @click="jumpPage" class="warn-btn">{{ $t('查看') }}</jw-button>
    </div>
    <iframe v-else ref="iframe" class="frame-container" :src="formatSrc" />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { getToken } from '@/utils/auth';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
console.log(t('编辑'));
const props = defineProps({
  src: {
    type: String,
    default: ''
  },
  height: {
    type: [Number, String],
    default: '100%'
  },
  border: {
    type: String,
    default: 'none'
  },
  query: {
    type: Object,
    default: () => {
      return {};
    }
  }
});
const iframe = ref();
const formatSrc = ref('');
const isWarnPage = ref(false);
const init = () => {
  const publicQuery = {
    token: getToken() || null
  };
  const _formatQuery = new URLSearchParams({ ...props.query, ...publicQuery }).toString();
  formatSrc.value = props.src + (props.src.includes('?') ? '&' : '?') + _formatQuery;
  isWarnPage.value = false;
  if (isIosOrSafari() && isFeishuDocUrl(props.src)) {
    isWarnPage.value = true;
  }
};
onMounted(() => {
  init();
});
const isIosOrSafari = () => {
  const isIos = /Mac|iPad|iPhone|iPod/.test(navigator.platform);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  return isIos && isSafari;
};
const isFeishuDocUrl = (url) => {
  return url?.indexOf('feishu.cn') > -1 && (url?.indexOf('wiki') > -1 || url?.indexOf('table') > -1);
};
const jumpPage = () => {
  window.open(formatSrc.value, '_blank');
};
</script>
<style scoped lang="less">
@import './xl-iframe.less';
</style>
